import React from "react"

import { Box, Grid, IconButton, Stack, Tooltip, Typography, } from "@mui/material"

import { i18n } from "@lingui/core"
import { DateTime } from "luxon"

import {
	mdiCalendarOutline,
	mdiPencilOutline,
} from "@mdi/js"
import Icon from "@mdi/react"

import { Trans } from "@lingui/macro"
import { Visit, SessionResponse, Asset } from "models"

export interface VisitDetailProps {
	data: Visit
	sessionData: SessionResponse
	showButtons?: boolean
	onEdit?: () => void
	onClick?: () => void
}

export interface VisitDetailState {
}

export class VisitDetail extends React.Component<VisitDetailProps, VisitDetailState> {
	static defaultProps = {
		showButtons: true,
	}

	private isSmallScreen: boolean = window.innerWidth < 1024

	private printDate = () => {
		let { dataOra } = this.props.data
		const dateTime = DateTime.fromJSDate(new Date(dataOra))
		const formattedDate = dateTime.toFormat("dd/MM/yyyy HH:mm")
		
		if (this.isSmallScreen) {
			return formattedDate
		}
		return i18n._({ id: "visits.date-label", message: "Data:" }) + " " + formattedDate
	}

	private getAssetAddress = () => {
		return this.props.data.asset?.address || "Indirizzo non disponibile"
	}

	render() {
		let iconColor: string = "primary.main"
		let today = new Date()
		let visitDate = new Date(this.props.data.dataOra)
		today.setHours(0, 0, 0, 0)
		visitDate.setHours(0, 0, 0, 0)

		// Se la data del sopralluogo è passata, colora l'icona di grigio
		if (visitDate.getTime() < today.getTime()) {
			iconColor = "secondary.main"
		}

		return (
			<Grid container spacing={2} alignItems="center" p={0.5} direction="row">
				<Grid item xs="auto">
					<Box
						component={Icon}
						path={mdiCalendarOutline}
						size="35px"
						sx={{
							color: "primary.contrastText",
							backgroundColor: iconColor,
							padding: "5px",
							mt: 2,
							borderRadius: "100%",
						}}>
					</Box>
				</Grid>
				<Grid item xs onClick={this.props.onClick}>
					<Stack direction="column">
						<Typography sx={{ fontSize: 16, fontWeight: "medium" }} color="primary">
							{this.printDate()}
						</Typography>
						<Typography sx={{ fontSize: 12, fontWeight: '600', color: "secondary.main" }}>
							{this.getAssetAddress()}
						</Typography>
						{this.props.data.referente && (
							<Typography sx={{ fontSize: 10 }}>
								<Trans id={"visits.referente"}>
									Referente: {this.props.data.referente}
								</Trans>
							</Typography>
						)}
					</Stack>
				</Grid>

				{this.props.showButtons &&
					<Grid item xs="auto">
						<Stack direction="row" spacing={0.7} sx={{ display: "block", }}>
							<Tooltip title="Modifica" placement="top" arrow>
								<IconButton
									sx={{
										color: "grey",
										backgroundColor: "transparent",
										":hover": {
											color: "secondary.main",
										},
									}}
									aria-label="edit"
									onClick={this.props.onEdit}
									disableFocusRipple
									disableRipple>
									<Icon path={mdiPencilOutline} size={1} />
								</IconButton>
							</Tooltip>
						</Stack>
					</Grid>
				}
			</Grid>
		)
	}
}
